// extracted by mini-css-extract-plugin
export default {"caseACocher":"CaseACocher_caseACocher__UFk5U","input":"CaseACocher_input__SuIB7","label":"CaseACocher_label__OVDOL"};